var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 127,
    viewBox: "0 0 197 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5406 126.061C90.4085 126.061 101.651 114.819 101.651 100.951C101.651 87.083 90.4085 75.8408 76.5406 75.8408C62.6728 75.8408 51.4307 87.083 51.4307 100.951C51.4307 114.819 62.6728 126.061 76.5406 126.061Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5603 127.001C88.4282 127.001 99.6703 115.759 99.6703 101.891C99.6703 88.0234 88.4282 76.7812 74.5603 76.7812C60.6924 76.7812 49.4502 88.0234 49.4502 101.891C49.4502 115.759 60.6924 127.001 74.5603 127.001Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1304 120.721C58.4604 117.601 52.3504 106.431 55.4704 95.7607",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3895 119.75L77.9395 117.75L82.2896 115.53L85.7495 117.52L81.3895 119.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4802 115.761L71.0303 113.761L75.3802 111.541L78.8402 113.531L74.4802 115.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5701 111.771L64.1201 109.771L68.4701 107.551L71.9302 109.541L67.5701 111.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.66 107.781L57.21 105.781L61.5601 103.561L65.02 105.551L60.66 107.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0994 115.3L86.6494 113.3L90.9994 111.08L94.4594 113.08L90.0994 115.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1902 111.31L79.7402 109.32L84.0902 107.09L87.5503 109.09L83.1902 111.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2802 107.321L72.8301 105.331L77.1802 103.101L80.6401 105.101L76.2802 107.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3699 103.33L65.9199 101.34L70.2699 99.1104L73.7299 101.11L69.3699 103.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4597 99.3401L59.0098 97.3501L63.3597 95.1201L66.8197 97.1201L62.4597 99.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8993 106.861L88.4492 104.871L92.7993 102.641L96.2593 104.641L91.8993 106.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.99 102.871L81.54 100.881L85.89 98.6611L89.35 100.651L84.99 102.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0798 98.8809L74.6299 96.8909L78.9799 94.6709L82.4398 96.6609L78.0798 98.8809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1698 94.8907L67.7197 92.9007L72.0697 90.6807L75.5298 92.6707L71.1698 94.8907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 98.4309L90.25 96.4309L94.6 94.2109L98.0601 96.2009L93.7 98.4309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2899 115.531L78.8398 113.531L83.1898 111.311L86.6499 113.301L82.2899 115.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3806 111.541L71.9307 109.541L76.2806 107.321L79.7406 109.321L75.3806 111.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4705 107.551L65.0205 105.551L69.3705 103.331L72.8304 105.331L68.4705 107.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5604 103.561L58.1104 101.571L62.4603 99.3408L65.9204 101.341L61.5604 103.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0007 111.08L87.5508 109.09L91.9008 106.86L95.3607 108.86L91.0007 111.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0906 107.091L80.6406 105.101L84.9906 102.871L88.4506 104.871L84.0906 107.091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1805 103.101L73.7305 101.111L78.0804 98.8809L81.5405 100.881L77.1805 103.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2704 99.1106L66.8203 97.1206L71.1704 94.8906L74.6304 96.8906L70.2704 99.1106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8007 102.641L89.3506 100.651L93.7006 98.4307L97.1606 100.421L92.8007 102.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8905 98.6604L82.4404 96.6604L86.7905 94.4404L90.2505 96.4304L85.8905 98.6604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9802 94.6702L75.5303 92.6702L79.8802 90.4502L83.3402 92.4402L78.9802 94.6702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7302 94.4905L83.2803 92.5005L87.6302 90.2705L91.0902 92.2705L86.7302 94.4905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4307 104.511L67.7106 104.581L66.3906 110.301C66.3906 110.741 66.3906 112.351 66.3906 112.781C66.3906 115.061 69.6306 116.921 73.6306 116.921C77.6306 116.921 80.8706 115.071 80.8706 112.781C80.8706 112.341 80.8706 110.731 80.8706 110.301L80.7706 109.901L79.4307 104.511Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7306 102.691C78.7806 103.161 79.4307 103.801 79.4307 104.511C79.4307 105.931 76.8406 107.081 73.6406 107.081C70.4406 107.081 67.8506 105.931 67.8506 104.511C67.8506 103.731 68.6406 103.031 69.8806 102.551",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8206 98.8408L77.6807 102.851C74.3707 104.501 69.6006 102.851 69.6006 102.851L70.2406 98.9108",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4406 94.3809C79.0706 94.9109 79.4307 95.5509 79.4307 96.2309C79.4307 98.0609 76.8406 99.5409 73.6406 99.5409C70.4406 99.5409 67.8506 98.0609 67.8506 96.2309C67.8506 95.5409 68.2106 94.9109 68.8406 94.3809",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6406 96.2305C76.38 96.2305 78.6006 95.1202 78.6006 93.7505C78.6006 92.3808 76.38 91.2705 73.6406 91.2705C70.9013 91.2705 68.6807 92.3808 68.6807 93.7505C68.6807 95.1202 70.9013 96.2305 73.6406 96.2305Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6006 88.7908C78.6006 89.3008 78.5206 89.8108 78.3906 90.2908C77.1006 94.9008 70.1806 94.9008 68.8906 90.2908C68.7506 89.8108 68.6807 89.3008 68.6807 88.7908C68.6807 84.6808 73.6406 81.3408 73.6406 81.3408C73.6406 81.3408 78.6006 84.6708 78.6006 88.7908Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6401 86.3104C75.4682 86.3104 76.9501 84.8285 76.9501 83.0004C76.9501 81.1724 75.4682 79.6904 73.6401 79.6904C71.8121 79.6904 70.3301 81.1724 70.3301 83.0004C70.3301 84.8285 71.8121 86.3104 73.6401 86.3104Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5303 94.7004L57.0702 92.8304L54.7002 92.9704L56.0303 91.0004L55.1603 88.7904L57.4402 89.4504L59.2803 87.9404L59.3602 90.3104L61.3502 91.5904L59.1202 92.4004L58.5303 94.7004Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.11 47.6114C189.74 40.3914 186.84 31.6114 179.62 27.9814",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.443 1.71452L180.067 0L178.353 4.37611L182.729 6.09063L184.443 1.71452Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.68 4.59082L119.62 14.7808L128.98 10.6008L120.68 4.59082Z",
    stroke: "#22B8CF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.33 56.2812L166.36 47.9512L162.14 57.2912L172.33 56.2812Z",
    stroke: "#22B8CF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87 111.801C116.46 111.841 116.04 111.731 115.7 111.441L112.49 108.811C111.81 108.251 111.71 107.241 112.27 106.561C112.83 105.881 113.84 105.781 114.52 106.341L117.73 108.971C118.41 109.531 118.51 110.541 117.95 111.221C117.67 111.561 117.28 111.761 116.87 111.801Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7804 1.19141L80.5703 13.7414",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.02 11.3105L147.07 25.2005",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.19 105.601L109.48 95.1611",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.22 88.8213C199.35 101.841 192.97 116.531 179.96 121.661",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.35 21.9009L165.45 9.71094",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.44 90.4606C138.892 90.4606 153.85 75.5025 153.85 57.0506C153.85 38.5988 138.892 23.6406 120.44 23.6406C101.988 23.6406 87.0303 38.5988 87.0303 57.0506C87.0303 75.5025 101.988 90.4606 120.44 90.4606Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.31 88.3708C135.762 88.3708 150.72 73.4126 150.72 54.9608C150.72 36.5089 135.762 21.5508 117.31 21.5508C98.8586 21.5508 83.9004 36.5089 83.9004 54.9608C83.9004 73.4126 98.8586 88.3708 117.31 88.3708Z",
    fill: "#66D9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.021 84.2612C133.043 84.2612 146.031 71.273 146.031 55.2512C146.031 39.2294 133.043 26.2412 117.021 26.2412C100.999 26.2412 88.0107 39.2294 88.0107 55.2512C88.0107 71.273 100.999 84.2612 117.021 84.2612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.43 48.3409L132.81 47.4109L130.56 49.0409L130.64 46.2709L128.4 44.6309L131.06 43.8509L131.92 41.2109L133.49 43.5009H136.26L134.57 45.7009L135.43 48.3409Z",
    stroke: "#66D9E8",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.401 34.8511L112.241 34.4311L111.231 35.1611L111.261 33.9211L110.261 33.1911L111.451 32.8411L111.841 31.6611L112.541 32.6811L113.781 32.6911L113.021 33.6711L113.401 34.8511Z",
    stroke: "#66D9E8",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.39 64.3216C116.44 64.1316 117.41 64.1516 118.15 64.2416C119.34 64.3816 120.36 65.2216 120.61 66.4016C121.04 68.4516 118.78 69.3416 118.78 69.3416C118.78 69.3416 112.21 70.8816 108.4 70.4616C104.59 70.0416 104.59 66.8616 103.53 63.6816C102.47 60.5016 100.35 58.6016 100.35 58.6016H99.7102L96.7302 55.1516C96.6002 55.0016 96.5303 54.8116 96.5303 54.6116C96.5303 53.9616 96.9503 53.3916 97.5603 53.1816C97.7103 53.1316 97.8803 53.1516 98.0203 53.2316L103.19 56.3316C103.75 56.6616 103.97 57.3616 103.71 57.9516L103.52 58.3916L104.16 59.4516C108.61 64.1116 108.82 66.6516 108.82 66.6516C111.36 65.1716 114.96 64.9616 114.96 64.9616C114.96 64.9616 115.38 64.3216 116.23 63.2716C117.08 62.2116 118.77 61.5816 118.77 61.5816C118.77 61.5816 118.92 59.9516 118.56 59.2516C118.12 58.4016 117.5 57.3416 116.65 56.5016C114.51 54.3616 113.26 50.9916 113.26 50.9916C113.26 50.9916 114.2 52.0516 115.43 51.3116C116.65 50.5716 115.17 48.6016 115.17 48.6016L117.5 49.7216",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.32 47.1611L123.01 48.4411L123.65 51.6111C123.65 51.6111 125.13 52.8811 125.34 54.3611C125.55 55.8411 125.34 60.2511 125.34 60.2511L124.28 65.8011C124.28 65.8011 123.01 68.7811 121.32 69.6211C119.63 70.4611 118.78 69.3411 118.78 69.3411",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.84 60.5013C101.84 60.5013 102.26 59.0213 104.17 59.4413",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.08 69.9307C120.08 69.9307 124.29 71.0907 128.31 69.4007C128.31 69.4007 130.64 69.6107 131.49 68.7607",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93 69.931L124.07 74.691L122.5 74.821C121.95 74.871 121.53 75.331 121.53 75.881V80.321C121.53 81.021 121.81 81.691 122.33 82.161C122.44 82.261 122.53 82.321 122.58 82.321C122.79 82.321 123.22 81.901 123.22 81.901L125.43 77.401L124.91 77.031C124.91 77.031 126.6 73.851 128.72 72.161C130.84 70.471 133.08 69.201 132.96 67.501C132.75 64.541 124.42 65.071 124.42 65.071",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.971 73.2012L126.621 74.4012",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.531 58.3914C103.531 58.3914 102.681 56.4814 101.201 57.1214C99.7207 57.7614 99.7207 58.6014 99.7207 58.6014",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.071 74.6914C124.071 74.6914 123.861 76.3814 124.921 77.0214",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.97 51.2911V47.5511C120.97 47.5511 122.17 45.2511 120.48 43.5611C118.79 41.8711 116.65 42.9711 116.24 44.2011C115.6 46.1111 116.67 50.1911 118.78 50.3711C120.9 50.5511 120.9 47.5911 120.9 47.5911",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11 46.3808C116.11 46.3808 116.23 43.7708 118.56 43.9808C120.89 44.1908 121.1 46.1008 121.1 46.1008",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.181 48.5908L111.581 43.3508L108.601 39.9208L106.921 37.0008L105.651 35.9408C105.651 35.9408 104.801 35.5208 104.381 34.6708C104.381 34.6708 104.151 34.1308 104.031 33.8308C104.001 33.7508 103.891 33.7508 103.851 33.8208C103.711 34.1108 103.561 34.6908 104.171 35.3008L102.021 35.1208C101.951 35.1108 101.931 35.2108 101.991 35.2408L103.951 36.1508C103.951 36.1508 103.311 36.1508 102.471 36.0408C102.441 36.0408 102.421 36.0708 102.441 36.0808C102.771 36.3208 103.471 36.7608 103.941 36.5908C103.941 36.5908 103.701 36.8308 103.011 36.9508C102.891 36.9708 102.861 37.1408 102.971 37.2008C103.241 37.3408 103.661 37.4708 104.151 37.3008",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.95 37.4209C104.37 38.2709 106.07 38.4809 106.07 38.4809L109.03 43.1409L111.78 47.8009C111.78 47.8009 112.42 50.5509 113.26 50.9809",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11 46.6507C116.11 46.6507 115.5 46.5307 115.76 47.1607C116.02 47.8007 116.23 48.4307 116.66 48.4307",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11 30.5512C121.11 29.6112 119.63 28.7412 119.63 28.7412C119.63 28.7412 119.21 28.7412 120.27 29.8012C120.69 30.2212 120.67 30.8912 120.67 30.8912",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47 29.3709C120.05 28.7309 120.89 29.1609 120.89 29.1609C120.89 29.1609 121.31 29.3709 121.53 30.6909C121.53 30.6909 121.32 31.4909 121.95 31.4909C122.59 31.4909 123.43 30.6409 123.64 31.0709L121.73 32.3409",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.18 30.6914C120.18 30.6914 120.9 30.8514 120.9 31.5914L120.26 33.1814L119.97 38.1714C119.93 38.8714 119.97 39.5814 120.08 40.2714L120.36 41.9714L120.16 43.2914",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.011 48.441L123.021 47.531C123.161 46.311 123.041 45.071 122.671 43.901L122.171 42.291L122.361 39.671C122.381 39.441 122.371 39.211 122.331 38.981L121.391 33.501",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.66 33.9609C120.66 33.9609 121.62 33.6109 122.11 32.1309",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.971 49.7713L122.591 51.6113L120.661 52.8613H119.231L116.181 49.0713",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.61 64.3208C118.61 64.3208 120.33 63.3108 120.4 62.5408C120.47 61.7708 121.53 58.8408 121.53 58.8408V62.8208C121.53 62.8208 121.55 64.6708 119.85 65.0208",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.61 66.3913C120.61 66.3913 123.44 63.6813 123.65 63.0413C123.86 62.4013 122.59 62.3113 122.59 62.3113L124.06 61.4713C124.06 61.4713 123.14 59.8713 123.08 59.1313C123.08 59.1313 123.2 60.0313 124.06 60.1613C124.92 60.2913 124.5 59.0213 123.65 58.3913C122.8 57.7513 121.53 55.9413 121.53 55.9413L123.35 56.9813C123.35 56.9813 121.44 55.2913 123.07 54.7213H121.76L122.23 53.4113C122.23 53.4113 122.59 53.9413 123.44 53.0913C124.29 52.2413 123.65 51.6113 123.65 51.6113",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.681 78.3311L124.531 78.9911",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.08 79.2812L124.1 80.1113",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5402 55.9717L98.6602 56.9917",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6603 55.0811L97.7402 56.2311",
    stroke: "#66D9E8",
    strokeWidth: 0.7831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.04 34.1506C129.526 34.1506 129.92 33.7566 129.92 33.2706C129.92 32.7846 129.526 32.3906 129.04 32.3906C128.554 32.3906 128.16 32.7846 128.16 33.2706C128.16 33.7566 128.554 34.1506 129.04 34.1506Z",
    stroke: "#66D9E8",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.559 56.717L129.101 55.7539L128.138 58.212L130.596 59.175L131.559 56.717Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.35 72.3312C101.12 72.3312 100.89 72.2412 100.71 72.0712L99.0604 70.4212C98.7104 70.0712 98.7104 69.5012 99.0604 69.1512C99.4104 68.8012 99.9802 68.8012 100.33 69.1512L101.98 70.8012C102.33 71.1512 102.33 71.7212 101.98 72.0712C101.81 72.2512 101.58 72.3312 101.35 72.3312Z",
    stroke: "#66D9E8",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.831 50.3008C144.521 61.7208 138.271 73.9408 126.851 77.6408",
    stroke: "#66D9E8",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0807 65.4404C88.7007 55.5104 91.5708 42.3204 101.501 35.9404",
    stroke: "#66D9E8",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6 85.1814C188.029 85.1814 193.24 79.97 193.24 73.5414C193.24 67.1128 188.029 61.9014 181.6 61.9014C175.171 61.9014 169.96 67.1128 169.96 73.5414C169.96 79.97 175.171 85.1814 181.6 85.1814Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.72 83.6013C189.149 83.6013 194.36 78.3899 194.36 71.9613C194.36 65.5327 189.149 60.3213 182.72 60.3213C176.291 60.3213 171.08 65.5327 171.08 71.9613C171.08 78.3899 176.291 83.6013 182.72 83.6013Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05 72.6611C188.71 76.4111 179.61 76.5011 179.61 76.5011C179.61 76.5011 176.71 68.1211 180.07 66.3211C184.14 64.1411 184.56 69.4911 184.56 69.4911C184.56 69.4911 189.45 68.3011 189.05 72.6611Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.46 67.5312C172.88 71.1813 173.75 76.2213 177.4 78.8013",
    stroke: "white",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5 118.86C160.586 118.86 167.14 112.306 167.14 104.22C167.14 96.1346 160.586 89.5801 152.5 89.5801C144.415 89.5801 137.86 96.1346 137.86 104.22C137.86 112.306 144.415 118.86 152.5 118.86Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81 116.841C160.895 116.841 167.45 110.286 167.45 102.201C167.45 94.1151 160.895 87.5605 152.81 87.5605C144.724 87.5605 138.17 94.1151 138.17 102.201C138.17 110.286 144.724 116.841 152.81 116.841Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.59 106.761C153.42 108.691 158.9 106.341 160.83 101.511",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.351 99.9201C146.859 99.9201 147.271 99.5082 147.271 99.0001C147.271 98.492 146.859 98.0801 146.351 98.0801C145.842 98.0801 145.431 98.492 145.431 99.0001C145.431 99.5082 145.842 99.9201 146.351 99.9201Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.801 94.9806C157.309 94.9806 157.721 94.5687 157.721 94.0606C157.721 93.5525 157.309 93.1406 156.801 93.1406C156.293 93.1406 155.881 93.5525 155.881 94.0606C155.881 94.5687 156.293 94.9806 156.801 94.9806Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.14 83.151C64.0547 83.151 81.8199 65.3857 81.8199 43.471C81.8199 21.5564 64.0547 3.79102 42.14 3.79102C20.2254 3.79102 2.45996 21.5564 2.45996 43.471C2.45996 65.3857 20.2254 83.151 42.14 83.151Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0502 81.0612C61.9648 81.0612 79.7301 63.2958 79.7301 41.3812C79.7301 19.4665 61.9648 1.70117 40.0502 1.70117C18.1355 1.70117 0.370117 19.4665 0.370117 41.3812C0.370117 63.2958 18.1355 81.0612 40.0502 81.0612Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0497 75.8316C59.0759 75.8316 74.4996 60.4079 74.4996 41.3816C74.4996 22.3554 59.0759 6.93164 40.0497 6.93164C21.0235 6.93164 5.59961 22.3554 5.59961 41.3816C5.59961 60.4079 21.0235 75.8316 40.0497 75.8316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4501 27.6216L19.6101 26.2616L16.3002 28.6516L16.4102 24.5716L13.1201 22.1716L17.0302 21.0216L18.2902 17.1416L20.6001 20.5016L24.6802 20.5116L22.1901 23.7416L23.4501 27.6216Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1499 18.4007L38.0499 17.3007L35.3999 19.2307L35.4899 15.9507L32.8398 14.0207L35.9799 13.0907L36.9999 9.9707L38.8499 12.6707L42.1299 12.6807L40.1399 15.2807L41.1499 18.4007Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.39 21.2312L54.03 20.3912L52 21.8612L52.0601 19.3512L50.04 17.8812L52.4399 17.1712L53.22 14.7812L54.64 16.8512H57.15L55.62 18.8412L56.39 21.2312Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5004 30.8011L64.4204 30.0611L62.6304 31.3611L62.6903 29.1511L60.9004 27.8511L63.0204 27.2211L63.7103 25.1211L64.9603 26.9411L67.1704 26.9511L65.8203 28.7011L66.5004 30.8011Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1199 43.9414L68.7299 43.4514L67.5399 44.3214L67.5798 42.8414L66.3799 41.9714L67.7999 41.5514L68.2599 40.1514L69.0898 41.3714H70.5698L69.6699 42.5414L70.1199 43.9414Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1198 54.2314C15.1698 54.2914 20.4797 60.2914 40.6997 60.2914C61.2997 60.2914 67.1797 55.4014 67.2297 55.3514C67.1397 55.4314 67.0997 55.4814 67.0997 55.4814L66.3698 61.4514L73.4497 61.6814C72.2297 62.9314 64.9197 69.1714 40.6897 69.1714C30.2797 69.1714 21.7997 67.7314 15.4797 64.8914C10.4397 62.6214 8.45973 60.2014 7.96973 59.5114L15.2898 59.9714L15.2097 54.3814C15.2297 54.3814 15.1998 54.3314 15.1198 54.2314Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3398 63.1613C57.2398 64.0413 54.0399 64.5113 50.8499 64.8213C47.6499 65.1313 44.4298 65.2413 41.2198 65.1913C38.0098 65.1013 34.7999 64.9213 31.6099 64.4613C28.4199 64.0613 25.2699 63.4112 22.1699 62.5312C25.3899 62.5612 28.5699 62.7412 31.7399 62.8412C34.9099 62.9612 38.0799 63.0512 41.2499 63.1012C44.4199 63.1912 47.5899 63.1713 50.7599 63.1913L60.3398 63.1613Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8503 41.8009C58.8503 41.8409 58.8503 41.8709 58.8503 41.8709L57.5903 43.1309C58.4303 40.6109 55.9004 35.1409 55.9004 35.1409L56.9904 33.8809C58.0504 36.0209 58.6903 38.3809 58.8303 40.8909C58.8303 40.9109 58.8303 40.9309 58.8303 40.9409C58.8403 41.2309 58.8503 41.5109 58.8503 41.8009Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9005 35.1507C55.9005 35.1507 58.4205 40.6107 57.5905 43.1407L54.6505 47.7607L50.4504 46.0807L49.1904 38.5107L52.1305 33.4707L55.9005 35.1507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9803 33.8806L55.8904 35.1406L52.1104 33.4606C52.1104 33.4606 49.5903 29.2606 47.0703 28.4106L47.4803 25.4706L47.6104 25.1406C51.7004 26.8206 55.0403 29.9506 56.9803 33.8806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4398 46.0703L54.6399 47.7503C54.6399 47.7503 54.6398 52.3803 52.9498 54.0503C52.8998 54.1003 52.8399 54.1603 52.7699 54.2103C50.9399 55.7603 46.2198 56.1503 46.2198 56.1503L45.3799 51.1103L50.4398 46.0703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5804 43.1311L58.8405 41.8711C58.8405 47.1511 56.5704 51.9111 52.9504 55.2111L52.8805 55.1411V54.3511L52.7705 54.2211C52.8305 54.1711 52.8904 54.1111 52.9504 54.0611C54.6404 52.3811 54.6405 47.7611 54.6405 47.7611L57.5804 43.1311Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1804 38.5111L50.4403 46.0711L45.3904 51.1211L38.2504 49.0111L36.5703 41.0311L42.0304 36.4111L49.1804 38.5111Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63 25.1507L47.5 25.4807L47.09 28.4207C44.57 27.5807 40.79 29.8007 40.79 29.8007C38.27 27.8107 34.79 28.2407 34.79 28.2407L35.13 24.7207C36.91 24.1307 38.81 23.8107 40.8 23.8107C43.2 23.8007 45.52 24.2807 47.63 25.1507Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0802 28.4203C49.6002 29.2703 52.1202 33.4703 52.1202 33.4703L49.1803 38.5103L42.0303 36.4103L40.7803 29.8003C40.7803 29.8003 44.5502 27.5803 47.0802 28.4203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3903 51.1205L46.2302 56.1605C46.2302 56.1605 43.2903 58.6405 40.7703 58.6705C37.4103 59.0705 33.1302 56.1605 33.1302 56.1605C33.1302 56.1605 31.9502 54.0605 31.9502 51.5405L38.2502 49.0205L45.3903 51.1205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2301 56.1607C46.2301 56.1607 50.9502 55.7707 52.7802 54.2207L52.8902 54.3507V55.1407L52.9601 55.2107C49.7501 58.1507 45.4702 59.9407 40.7802 59.9407C40.7602 59.9407 40.7401 59.9407 40.7301 59.9407C41.4001 59.8507 41.6001 59.6507 41.2001 59.5207C39.9401 59.1107 40.7902 58.6607 40.7902 58.6607C43.2902 58.6407 46.2301 56.1607 46.2301 56.1607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.77 28.2306C34.77 28.2306 38.25 27.8106 40.77 29.7906L42.02 36.4006L36.5601 41.0306L29.83 39.7706L29 33.3706C30.71 29.9106 34.77 28.2306 34.77 28.2306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5701 41.0307L38.2501 49.0107L31.9501 51.5307C28.1601 49.8407 26.9102 45.6407 26.9102 45.6407C27.7502 41.0207 29.8501 39.7607 29.8501 39.7607L36.5701 41.0307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9504 51.5412C31.9504 54.0612 33.1305 56.1612 33.1305 56.1612L30.2305 56.5512H30.2205C27.7705 54.7912 25.8005 52.4511 24.4805 49.7111C24.6705 49.9611 24.1605 47.1512 24.0605 45.6612H26.9005C26.9105 45.6512 28.1604 49.8512 31.9504 51.5412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7205 59.9406C39.5705 59.9406 38.4405 59.8306 37.3605 59.6106C37.3405 59.6106 37.3205 59.6106 37.3105 59.6006C35.4705 59.1606 33.0605 58.2606 30.2705 56.5606C30.2605 56.5506 30.2405 56.5406 30.2305 56.5306L33.1305 56.1406C33.1305 56.1406 37.4105 59.0406 40.7705 58.6506C40.7705 58.6506 39.9205 59.0906 41.1805 59.5106C41.5905 59.6506 41.3905 59.8506 40.7205 59.9406Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0201 33.3709C29.0201 33.3709 26.9101 33.0409 25.2201 33.4709C23.5901 33.8809 29.9701 27.4809 30.3201 27.1309C30.3301 27.1209 30.3401 27.1109 30.3401 27.1109L30.3601 27.1009L35.0502 24.7309C35.0702 24.7209 35.0901 24.7109 35.1101 24.7109L34.7701 28.2309C34.7701 28.2309 30.7101 29.9109 29.0201 33.3709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7002 41.8709C22.7002 35.7809 25.7102 30.4009 30.3202 27.1309C29.9702 27.4809 23.5802 33.8709 25.2202 33.4709C26.9102 33.0509 29.0203 33.3709 29.0203 33.3709L29.8502 39.7709C29.8502 39.7709 27.7503 41.0309 26.9103 45.6509H24.0702C23.3902 45.2609 22.8202 43.1009 22.7402 42.8009V42.7909C22.7102 42.4909 22.7002 42.1809 22.7002 41.8709Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8203 40.9512C58.8403 41.2312 58.8503 41.5112 58.8503 41.8112",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3604 27.1008C31.7804 26.0908 33.3604 25.2908 35.0504 24.7308C35.0704 24.7208 35.0904 24.7108 35.1104 24.7108C36.8904 24.1208 38.7904 23.8008 40.7804 23.8008C43.2104 23.8008 45.5204 24.2808 47.6304 25.1508C51.7104 26.8208 55.0504 29.9408 56.9904 33.8808C58.0504 36.0208 58.6903 38.3808 58.8303 40.8908",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7302 42.7909C22.7102 42.4909 22.7002 42.1809 22.7002 41.8709C22.7002 35.7809 25.7102 30.4009 30.3202 27.1309",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4303 49.5608C23.4503 47.4908 22.8502 45.2108 22.7402 42.8008",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3105 59.6103C34.7205 59.1103 32.3405 58.0603 30.2705 56.5703",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8501 41.8711C58.8501 47.1511 56.5801 51.9111 52.9601 55.2111C49.7501 58.1511 45.4702 59.9411 40.7802 59.9411C40.7602 59.9411 40.7401 59.9411 40.7301 59.9411C39.5801 59.9411 38.4501 59.8311 37.3701 59.6111",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7803 29.8003C40.7803 29.8003 44.5602 27.5803 47.0802 28.4203C49.6002 29.2703 52.1202 33.4703 52.1202 33.4703L49.1803 38.5103L42.0303 36.4103L40.7803 29.8003Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3603 27.1012L35.0504 24.7312L35.1103 24.7012V24.7112L34.7704 28.2312C34.7704 28.2312 30.7104 29.9112 29.0104 33.3712C29.0104 33.3712 26.9003 33.0412 25.2103 33.4712C23.5803 33.8812 29.9604 27.4812 30.3104 27.1312",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3203 27.1306C30.3303 27.1206 30.3403 27.1106 30.3403 27.1106L30.3604 27.1006",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9806 33.8809L55.8906 35.1409C55.8906 35.1409 58.4106 40.6009 57.5806 43.1309L58.8406 41.8709C58.8406 41.8709 58.8406 41.8409 58.8406 41.8009C58.8406 41.6809 58.8407 41.3709 58.8107 40.9409C58.8107 40.9209 58.8107 40.9009 58.8107 40.8909C58.7407 39.2909 58.3906 36.0309 56.9806 33.8809Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6406 47.7503L50.4406 46.0703L45.3906 51.1103L46.2306 56.1503C46.2306 56.1503 50.9506 55.7603 52.7806 54.2103C52.8406 54.1603 52.9006 54.1003 52.9606 54.0503C54.6406 52.3803 54.6406 47.7503 54.6406 47.7503Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2504 49.0105L36.5703 41.0305L29.8403 39.7705C29.8403 39.7705 27.7404 41.0305 26.9004 45.6505C26.9004 45.6505 28.1503 49.8505 31.9403 51.5405L38.2504 49.0105Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2705 56.5712C30.2605 56.5612 30.2405 56.5512 30.2305 56.5412H30.2205C27.7705 54.7812 25.8005 52.4412 24.4805 49.7012",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3105 59.6103C35.4705 59.1703 33.0605 58.2703 30.2705 56.5703",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3605 59.6203C37.3405 59.6203 37.3205 59.6204 37.3105 59.6104",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2305 56.5404L33.1305 56.1504C33.1305 56.1504 37.4105 59.0504 40.7705 58.6604C40.7705 58.6604 39.9205 59.1004 41.1805 59.5204C41.5805 59.6504 41.3804 59.8604 40.7104 59.9404C40.0404 60.0204 38.8805 59.9804 37.3505 59.6104",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7705 28.2306C34.7705 28.2306 38.2505 27.8106 40.7705 29.7906",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5703 41.0311L42.0304 36.4111",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8505 39.7711L29.0205 33.3711",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.39 51.1207L38.25 49.0107",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1807 38.5107L50.4406 46.0707",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6406 47.7509L57.5806 43.1309",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9001 35.1507L52.1201 33.4707",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0801 28.4205L47.4901 25.4805",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2305 56.1611C46.2305 56.1611 43.2905 58.6411 40.7705 58.6711",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1302 56.161C33.1302 56.161 31.9502 54.061 31.9502 51.541",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7305 42.8008C22.8105 43.1008 23.3805 45.2608 24.0605 45.6508H26.9005",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7305 42.791V42.801",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7207 42.7607C22.7207 42.7607 22.7207 42.7707 22.7307 42.7907",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3805 49.4404C24.4005 49.4904 24.4105 49.5304 24.4205 49.5604C24.4505 49.6304 24.4605 49.6704 24.4805 49.7004C24.6705 49.9504 24.1605 47.1404 24.0605 45.6504",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8906 55.1406V54.3506",
    stroke: "#3BC9DB",
    strokeWidth: 1.0441,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportRightImage);
export default __webpack_public_path__ + "static/media/sportRightImage.2208e9032a7e2798bf406a29ebd6bf19.svg";
export { ForwardRef as ReactComponent };